import { useGameState } from '../hooks/useGameState';
import { stones } from '../data/stones';
import { StoneCard } from '../components/StoneCard';
import type { Screen } from '../App';

interface CollectionScreenProps {
  onNavigate: (next: Screen, stoneId?: string) => void;
}

export function CollectionScreen({ onNavigate }: CollectionScreenProps) {
  const { state, ownedStone } = useGameState();
  return (
    <div className="screen collection">
      <h1>コレクション</h1>
      <p className="collection__summary">
        ✿ {state.inventory.length} / {stones.length} 種 所持 ✿
      </p>
      <div className="collection__grid">
        {stones.map((s) => (
          <StoneCard
            key={s.id}
            stone={s}
            owned={ownedStone(s.id)}
            onClick={() => onNavigate('detail', s.id)}
          />
        ))}
      </div>
    </div>
  );
}
